import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { sortBy } from 'lodash';
import * as moment from 'moment';
import { CommonConstant } from '../../shared/constants/common.constants';

import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { MessageService } from '../../shared/services/message.service';
import { DateConstants } from '../constants/date.constants';
import { MemberEmailInfo } from '../interface/member-email-info.interface';
import { MemberEmailLogSearchRequest } from '../interface/member-email-log-search-request.interface';
import { MemberEmailLog } from '../interface/member-email-log.interface';
import { ProfileInformation } from '../interface/profile-info';
import { StoreCountry } from '../interface/store-country.interface';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { CustomerService } from '../services/customer.service';
import { EmailLogService } from '../services/email-log.service';
import { Utils } from '../../shared/Utils/utils';
import { StoreService } from '../../shared/services/store.service';
import { MemberTypeEnum } from '../enums/member-type.enum';




@Component({
    selector: 'app-member-email-log',
    templateUrl: '../templates/template1/views/member-email-log.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/profile-info.less'
    ]

})
export class MemberEmailLogComponent implements OnInit, OnDestroy {
    @Input() distributorInfo: DistributorInfo;
    @Input() fboid: string;
    storeCountries: StoreCountry[] = [];
    emailSearchForm: FormGroup;
    fboProfileInfo: ProfileInformation;
    memberhomeCountryCode: string;
    memberEmailLogs: MemberEmailLog[];
    pageNumber = 1;
    pageSize = 25;
    pageCount = 0;
    pageRecords: number[] = [25, 50, 100];
    pageSizeCtrl = new FormControl(25);
    storeInfo: StoreConfig;
    paginationId: string;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    maxDate: moment.Moment;
    minDate: Date;
    timeZoneOffset: number;
    stores = [];
    memberTypeEnum = MemberTypeEnum;
    constructor(
        private _customerService: CustomerService,
        private _formbuilder: FormBuilder,
        private _emailService: EmailLogService,
        private messageService: MessageService,
        private storeService: StoreService,
    ) {

    }

    ngOnInit(): void {
        this.getStoreTimeZoneInfo();
        this.paginationId = this.fboid;
        this.getFboProfileInformation();
        this.updatePaginationVariables();

    }

    /**
     * @description
     * @date 2019-07-10
     * @memberof MemberEmailLogComponent
     */
    getStoreCountries() {
        this._customerService.getAllStoreCountries().subscribe(response => {
            if (response && response.length > 0) {
                this.storeCountries = response;
                this.storeCountries = sortBy(this.storeCountries, 'name');
                if (this.fboProfileInfo) {
                    const memberhomeCountry = this.storeCountries
                        .find(x => x.homeCountryCode === this.fboProfileInfo.homeCountryCode);
                    if (memberhomeCountry) {
                        this.memberhomeCountryCode = memberhomeCountry.homeCountryCode;
                    }
                }
                const defaultOpt = {
                    homeCountryCode: 'ALL',
                    name: 'ALL'
                };
                this.storeCountries.splice(0, 0, defaultOpt as any);
                this.createEmailLogSearchForm();
            }
        });
    }

    /**
    * @description
    * @date 2019-07-10
    * @memberof MemberEmailLogComponent
    */
    getFboProfileInformation() {
        this._customerService.getMemberInformationFromTitan(this.fboid)
            .subscribe(response => {
                if (response && response.isSuccess) {
                    this.fboProfileInfo = response;
                    this.getStoreInfo();
                    this.getStoreCountries();
                }
            },
                error => {
                    this.getStoreInfo();
                    this.getStoreCountries();
                });
    }

    /**
     * @description
     * @date 2019-07-12
     * @memberof MemberEmailLogComponent
     */
    getStoreInfo(orderCountryCode ?: string):void {
      let countryCode=(this.fboProfileInfo && (this.fboProfileInfo.homeCountryCode
        && orderCountryCode && (this.fboProfileInfo.homeCountryCode === orderCountryCode))) ?
         this.fboProfileInfo.homeCountryCode : (orderCountryCode ?
            orderCountryCode :this.fboProfileInfo.homeCountryCode);
        this._customerService.getStoreInfoFromConfig([countryCode])
            .subscribe(response => {
                if (response) {
                    this.storeInfo = response;
                    this.maxDate = moment.utc(new Date())
                    .utcOffset(this.storeInfo.timeZoneOffset);
                }
            });
    }

    getStoreTimeZoneInfo(): void {
      this.storeService.getStoresLookup(false, true).subscribe((response) => {
        if (response) {
          this.stores = response;
        } else {
          this.stores = [];
        }
      }, (error) => {
        this.stores = [];
      });
    }
    /**
   * @description
   * @date 2019-07-10
   * @memberof MemberEmailLogComponent
   */
    private getMemberEmailLogs(memberEmailLog: MemberEmailLogSearchRequest, memberId: number): void {
        if (memberEmailLog && memberId) {
            const memberEmailLogRequest: MemberEmailLogSearchRequest = this.prepareMemberEmailLogRequest(memberEmailLog, this.distributorInfo.distributorId);
            this._emailService.getMemberEmailLogs(memberId, memberEmailLogRequest, this.pageSize, this.pageNumber)
                .subscribe(response => {
                    if (response) {
                        if (response.requestLookUpDetails && response.requestLookUpDetails.length > 0) {
                            response.requestLookUpDetails.forEach(x => {
                              let store=null;
                              if (this.stores.length > 0) {
                               this.stores.forEach(y => {
                                  if (y.homeCountryCode && x.countryCode &&
                                    y.homeCountryCode === x.countryCode) {
                                    store = y;
                                    // if (store.offset) {
                                    //   x.sentDate = moment.utc(x.sentDate)
                                    //     .utcOffset(store.offset).format('DD-MMM-YYYY HH:mm:ss');
                                    // }
                                  }
                                });

                              }
                                if(this.storeInfo != null && this.storeInfo.timeZoneOffset != null) {
                                    x.sentDate = moment.utc(x.sentDate)
                                        .utcOffset(+this.storeInfo.timeZoneOffset).format('DD-MMM-YYYY HH:mm:ss');
                                }
                                else{
                                    x.sentDate = moment.utc(x.sentDate)
                                        .utcOffset(0).format('DD-MMM-YYYY HH:mm:ss');
                                }
                            });
                            this.memberEmailLogs = response.requestLookUpDetails;
                            this.pageCount = response.totalCount;
                        } else {
                            this.memberEmailLogs = [];
                            this.updatePaginationVariables();
                        }
                    } else {
                        this.memberEmailLogs = [];
                        this.updatePaginationVariables();
                    }
                }, error => {
                    this.memberEmailLogs = [];
                    this.updatePaginationVariables();
                });
        }
    }

    /**
     * @description
     * @date 2019-07-16
     * @private
     * @memberof MemberEmailLogComponent
     */
    private updatePaginationVariables(): void {
        this.pageNumber = 1;
        this.pageSize = 25;
        this.pageCount = 0;
    }

    /**
     * @descriptionssssss
     * @date 2019-07-16
     * @param {number} pageNumber
     * @memberof MemberEmailLogComponent
     */
    pageChange(pageNumber: number): void {
        this.pageNumber = pageNumber;
        this.getMemberEmailLogs(this.emailSearchForm.value, this.distributorInfo.memberId);
    }

    /**
     * @description
     * @date 2019-07-11
     * @private
     * @memberof MemberEmailLogComponent
     */
    private prepareMemberEmailLogRequest(memberEmailLog: MemberEmailLogSearchRequest, distributorId : string): MemberEmailLogSearchRequest {
        const timeZoneOffsetString = this.storeInfo && this.storeInfo.timeZoneOffset ? this.convertOffsetToTimeString(this.storeInfo.timeZoneOffset) : "Z";
        const memberEmailLogRequest: MemberEmailLogSearchRequest = {
            countryCode: memberEmailLog.countryCode,
            sentTo: memberEmailLog.sentTo,
            distributorId: distributorId,
            startDate: moment(memberEmailLog.startDate, 'DD-MM-YYYY').format('DD-MMM-YYYY'),
            endDate: moment(memberEmailLog.endDate, 'DD-MM-YYYY').format('DD-MMM-YYYY'),
            subject: memberEmailLog.subject,
            sortBy: 'desc',
            sortOrder: 'endDate',
            timeZoneOffset: timeZoneOffsetString
        };
        return memberEmailLogRequest;
    }

    convertOffsetToTimeString(offset: number): string {
        const offsetSign = offset < 0 ? "-" : "+";
        offset = Math.abs(offset);
        const hours = Math.floor(offset);
        const minutes = Math.round((offset % 1) * 100);
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        return offsetSign + `${formattedHours}:${formattedMinutes}`;
    }

    /**
     * @description
     * @date 2019-07-11
     * @param {number} pagePerRecords
     * @memberof MemberEmailLogComponent
     */
    pagePerRecords(pagePerRecords: number): void {
        this.pageSize = pagePerRecords;
        this.getMemberEmailLogs(this.emailSearchForm.value, this.distributorInfo.memberId);
    }

    /**
     * @description
     * @date 2019-07-10
     * @memberof MemberEmailLogComponent
     */
    createEmailLogSearchForm(): void {
        const startDate = moment(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)).format(DateConstants.DateFormat);
        const endDate = moment(new Date()).format(DateConstants.DateFormat);
        this.emailSearchForm = this._formbuilder.group({
            countryCode: [this.memberhomeCountryCode ? this.memberhomeCountryCode : 'ALL', Validators.required],
            startDate: [moment(startDate, 'DD-MMM-YYYY'), Validators.required],
            endDate: [moment(endDate, 'DD-MMM-YYYY'), Validators.required],
            subject: [''],
            sentTo: [this.fboProfileInfo ? this.fboProfileInfo.email : '']
        });
        this.minDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
         //  To Do: Latency Issue
        //this.emailLogSearch();
    }

    /**
     * @description
     * @date 2019-07-11
     * @memberof MemberEmailLogComponent
     */
    clearFields(): void {
        this.emailSearchForm.patchValue({
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
            subject: [''],
            sentTo: []
        });
        this.memberEmailLogs = [];
        this.updatePaginationVariables();
    }

    /**
     * @description
     * @date 2019-07-15
     * @memberof MemberEmailLogComponent
     */
    emailLogSearch(): void {
        this.updatePaginationVariables();
        this.getMemberEmailLogs(this.emailSearchForm.value, this.distributorInfo.memberId);
    }


    /**
    * @description update selected date into form values
    * @date 2018-01-03
    * @memberof MemberEmailLogComponent
    */
    emailLogTransformDate(date: any, isStartDate: boolean) {
        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DOBConvertFormat);
        if (dateMomentObj) {
            if (isStartDate) {
                if (this.emailSearchForm.controls['startDate'].valid) {
                    this.emailSearchForm.controls['startDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
                    this.minDate = new Date(moment(this.emailSearchForm.controls['startDate'].value).format('DD-MMM-YYYY'));
                }
            } else if (this.emailSearchForm.controls['endDate'].valid) {
                this.emailSearchForm.controls['endDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
            }
        }
    }

    /**
    * @description Set minimum date while selecting date from picker
    * @date 2019-07-19
    * @memberof JoinPromotionsComponent
    */
    setMinDate(): void {
        this.minDate = new Date(moment(this.emailSearchForm.controls['startDate'].value).format('DD-MMM-YYYY'));
    }

    /**
    * @description Set minimum date while selecting date from picker
    * @date 2019-07-19
    * @memberof MemberEmailLogComponent
    */
   convertStartDate(date: any): void {
        this.emailSearchForm.controls['startDate'].setValue(moment(date, 'DD-MMM-YYYY'));
}

    /**
     * @description convert to Date Format
     * @date 2019-06-12
     * @param {string} date
     * @memberof MemberEmailLogComponent
     */
    convertEndDate(date: any): void {
        this.emailSearchForm.controls['endDate'].setValue(moment(date, 'DD-MM-YYYY'));
    }


    /**
     * @description
     * @date 2019-07-15
     * @param {MemberEmailLog} memberEmailLog
     * @memberof MemberEmailLogComponent
     */
    navigateToEmailDetils(memberEmailLog: MemberEmailLog): void {
        const memberEmailInfo: MemberEmailInfo = {
            storeInfo: this.storeInfo,
            memberEmailLog: memberEmailLog,
            distributorInfo: this.distributorInfo
        };
        this.messageService.setMemberEmailViewTab(memberEmailInfo);
    }

    ngOnDestroy(): void {

    }


    
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/member-email-log.component.ts